<template>
    <section
        class="bg-gradient-to-b from-black to-[#25282a] py-[90px] px-0 text-[18px] bg-cover at1024:py-[180px]"
        id="webinars-header"
    >
        <div
            class="max-w-[730px] at1024:max-w-[1460px] w-auto my-0 mx-auto py-0 px-[15px] at1024:pr-0 at1024:pl-[30px] box-border block relative"
        >
            <div
                class="block text-[#25282a] box-border relative px-0 mx-0 at1024:flex"
            >
                <div
                    class="relative ml-0 w-full inline-block mb-[2em] text-[#97999b] box-border at1024:w-[47.5%]"
                >
                    <small
                        class="text-[#fe1940] font-bold !block !tracking-widest text-[0.9em] !mb-[1em] !uppercase"
                        >Webinars</small
                    >
                    <h1
                        class="font-bold text-[30px] !mb-[30px] leading-[1.1em] at1024:text-[60px]"
                    >
                        <span class="text-white">Get a pro tour of SECLOCK</span
                        ><br />For you and your team
                    </h1>

                    <h2
                        class="text-[20px] leading-[1.4em] mb-[1.1em] at1024:text-[23px]"
                    >
                        Register for a private walk-through of SECLOCK.com–for
                        yourself or your entire company–detailing industry-first
                        features and functionality that will make searching and
                        sourcing the most complete inventory on the planet a
                        snap.
                    </h2>

                    <div class="mt-[1em] mx-0 mb-[1.5em] block at768:flex">
                        <a
                            class="typeform-share btn btn-white-on-red shadow-[0_0_0_2px_rgb(253 25 64)] w-full flex justify-center items-center at768:w-fit mb-[1em]"
                            href="https://sld.typeform.com/to/SD2n9A"
                            data-mode="popup"
                            target="_blank"
                            >Register for a tour</a
                        >

                        <a
                            href="#webinars-overview"
                            class="btn-white-outline w-full flex justify-center items-center mb-[1em] at768:w-fit at768:ml-[1em]"
                            @click.prevent="()=>useHelpers().scrollToId('webinars-overview')"
                            >Learn More</a
                        >
                    </div>
                </div>

                <div
                    class="overflow-hidden relative inline-block w-full mb-[2em] box-border !text-center at1024:ml-[5%] at1024:w-[47.5%]"
                >
                    <img
                        src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/webinars-header"
                        alt="Webinar graphic"
                    />
                </div>
            </div>
        </div>
    </section>

    <section
        class="bg-[#fbfbfb] py-[90px] px-0 relative block text-[18px] text-[#25282a] leading-[1.4] at1024:py-[180px]"
        id="webinars-overview"
    >
        <div
            class="wrap wrap-compact relative"
        >
            <div class="text-[#63666a] !text-center !block !mb-[4em]">
                <h3
                    class="text-[40px] font-bold leading-[1em] !mb-[30px] -tracking-[0.01em] at1024:text-[80px]"
                >
                    Topics Covered
                </h3>
                <h4
                    class="text-[28px] text-gray-400 leading-[1.2em] font-medium mb-[1.1em] mt-0 mx-0 at1024:text-[35px]"
                >
                    Learn about advanced features that make SECLOCK.com the
                    premier destination for your door hardware needs.
                </h4>
            </div>

            <div class="block at768:flex">
                <div class="relative ml-0 w-full inline-block mb-[2em]">
                    <p class="font-bold mb-[1em]">Searching</p>
                    <ul class="m-0">
                        <li class="flex" v-for="search in searchingChecks">
                            <BaseSvg
                                name="icon-check"
                                class="text-[#55b776] mr-2"
                            />
                            {{ search }}
                        </li>
                    </ul>
                </div>
                <div
                    class="relative ml-0 w-full inline-block mb-[2em] at768:ml-[5%]"
                >
                    <p class="font-bold mb-[1em]">Products</p>
                    <ul class="m-0">
                        <li
                            class="flex items-center"
                            v-for="product in productsChecks"
                        >
                            <BaseSvg
                                name="icon-check"
                                class="text-[#55b776] mr-2"
                            />
                            {{ product }}
                        </li>
                    </ul>
                </div>
            </div>

            <div class="block at768:flex">
                <div class="relative ml-0 w-full inline-block mb-[2em]">
                    <p class="font-bold mb-[1em]">The Cart</p>
                    <ul class="m-0">
                        <li
                            class="flex items-center"
                            v-for="cartCheck in cartChecks"
                        >
                            <BaseSvg
                                name="icon-check"
                                class="text-[#55b776] mr-2"
                            />
                            {{ cartCheck }}
                        </li>
                    </ul>
                </div>
                <div
                    class="relative ml-0 w-full inline-block mb-[2em] at768:ml-[5%]"
                >
                    <p class="font-bold mb-[1em]">Your Account</p>
                    <ul class="m-0">
                        <li
                            class="flex items-center"
                            v-for="accountCheck in yourAccountChecks"
                        >
                            <BaseSvg
                                name="icon-check"
                                class="text-[#55b776] mr-2"
                            />
                            {{ accountCheck }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>

    <section
        class="bg-[#25282a] text-white py-[90px] px-0 at1024:py-[180px] relative block box-border text-[18px]"
    >
        <div
            class="wrap wrap-compact text-center"
        >
            <h4
                class="font-medium text-[28px] text-[#c8c9c7] at1024:text-[35px] leading-[1.2em]"
            >
                And many more topics spanning all areas of the site!
                <a href="#webinars-header" @click.prevent="() => useHelpers().scrollToId('webinars-header')" class="text-white underline hover:text-red"
                    >Register Now</a
                >
            </h4>
        </div>
    </section>
    <Meta
        title="Webinars"
        description="Join us for a 30-minute webinar – with Q & A chat – detailing industry-first features and functionality of SECLOCK.com."
        :noFollow="true"
    />
</template>

<script>
import { BaseSvg, Meta } from "@/Components";
import {useHelpers} from "@/Composables";

export default {
    name: "page-webinars",
    methods: {useHelpers},
    components: { BaseSvg, Meta },
    data() {
        return {
            searchingChecks: [
                "Keyword searching",
                "Advanced category filtering",
                "Advanced product filtering",
                "Searching by manufacturer",
            ],
            productsChecks: [
                "Real-time costs and inventory",
                "Inventory by location",
                "Related products",
                "Saving favorites",
            ],
            cartChecks: [
                "Saving your cart",
                "Adding items by quick search",
                "Building a cart manually",
                "Saving a cart as a quote",
            ],
            yourAccountChecks: [
                "Orders and invoices",
                "Account reporting",
                "Quotes",
                "Changing your password",
            ],
        };
    },
};

(function() { var qs,js,q,s,d=document, gi=d.getElementById, ce=d.createElement, gt=d.getElementsByTagName, id="typef_orm_share", b="https://embed.typeform.com/"; if(!gi.call(d,id)){ js=ce.call(d,"script"); js.id=id; js.src=b+"embed.js"; q=gt.call(d,"script")[0]; q.parentNode.insertBefore(js,q) } })()
</script>
